import React, { useState, useEffect } from 'react'
import data from '../../app.json';

export default function Menu(props) {
  const [toolTipIndex, setToolTipIndex] = useState(-1);
  const [toolTipVisible, setToolTipVisible] = useState(false);

  useEffect(() => {
    // if we return to the menu before completing a trip, call tearDown
    if (props.scoring.currentTrip > -1) {
      props.scoring.tearDownTrip();
    }
  }, [])

  const isUnlocked = index => {
    if (!data.modules[index].locked) return true;
    const unlockers = data.modules[index].unlockers
    return unlockers.filter(e => props.progress[e].complete).length === unlockers.length
  }

  const handleItemClick = index => {
    if (data.locked && !props.isDevEnvironment) {
      if ((props.progress[index - 1] || {complete: true}).complete || props.progress[index].complete) {
        props.setModuleIndex(index);
      }
    } else {
      props.setModuleIndex(index);
    }
  }

  const showToolTip = index => {
    if (index > 0 && index < 5) {
      setToolTipIndex(index);
      setToolTipVisible(true);
    }
  }

  const hideToolTip = () => {
    setToolTipVisible(false);
    //setToolTipIndex(-1);
  }

  const generateMenuItems = () => {
    return data.modules.map((element, index) => {
      return (<div
        className={`menu-item ` +
                `${props.progress[index].complete ? 'complete ' : 'incomplete '}` +
                `${isUnlocked(index) ? 'unlocked ' : 'locked '}` +
                `${!element.required ? 'not-required ' : 'required '}` +
                `${props.progress[index].furthestStepIndex > 0 ? 'started' : 'not-started'}`}
        key={index}
        onClick={isUnlocked(index) ? () => handleItemClick(index) : () => {}}
        onMouseEnter={() => showToolTip(index)}
        onMouseLeave={hideToolTip}
        >
        
        <div className={`score  ${element.name}`}>{element.tripId>=0 && props.progress[index].complete ? props.scoring.getTripScore(element.tripId - 1) + '%':''}</div>
          {/* <div className={`score  ${element.name}`}>100%</div>  */}
          <div className={`lock-symbol`} />
      </div>)
    })
  };

  return (
    <div className="Menu">
      <div className="title">
      </div>
        <div className={`tooltip tooltip-${toolTipIndex} ${toolTipVisible && data.modules[toolTipIndex].menuToolTip ? 'visible' : 'hidden'}`} dangerouslySetInnerHTML={{__html: toolTipIndex > 0 && toolTipIndex < 5 ? data.modules[toolTipIndex].menuToolTip : ''}} />
      <div className="menu-wrapper">
        {generateMenuItems()}
        <div className={`prompt`}>
          {props.data.prompt}
        </div>
      </div>
      <div className={`crossing-arm`} />
    </div>
  )
}
